import { Navigate, useSearchParams } from "react-router-dom";
import { validateReturnTo } from "./returnTo";

export const PostLoginRedirect = () => {
  const [params] = useSearchParams();
  const target = validateReturnTo(params.get("return_to")) ?? "/";
  return <Navigate to={target} replace />;
};
